// @ts-nocheck


import React, { useState } from 'react';
import { navigate } from '../../../lib/routerAdapter';
import moment from 'moment';
import qs from 'query-string';
import { DatePicker } from '../../../components/ant/DatePicker';
import { Popconfirm } from '../../../components/ui';

import { formatDateTimeToISOString } from './../../../lib/helpers';






export default ({ washingPriceListId, closeDropdown }) => {
  const [startDate, setStartDate] = useState(
    moment.utc().startOf('day').toISOString()
  );
  const [endDate, setEndDate] = useState(
    moment.utc().add(1, 'month').toISOString()
  );
  return (
    <Popconfirm
      overlayStyle={{
        zIndex: 2000
      }}
      placement="left"
      title={
      <>
          <p>Выберите дату начала действия прейскуранта</p>
          <DatePicker
          popupStyle={{
            zIndex: 2001
          }}
          format="DD.MM.YYYY"
          disabledDate={(current) => current.isBefore(new Date(), 'day')}
          onChange={(value, dateString) => {
            const dateTime = formatDateTimeToISOString(
              value,
              dateString,
              'DD.MM.YYYY'
            );
            setStartDate(dateTime);
          }} />

          <p>Выберите дату окончания действия прейскуранта</p>
          <DatePicker
          popupStyle={{
            zIndex: 2001
          }}
          format="DD.MM.YYYY"
          disabledDate={(current) => current.isBefore(new Date(), 'day')}
          onChange={(value, dateString) => {
            const dateTime = formatDateTimeToISOString(
              value,
              dateString,
              'DD.MM.YYYY'
            );
            setEndDate(dateTime);
          }} />

        </>
      }
      onConfirm={() => {
        closeDropdown();
        navigate(
          `/admin/washing-price-list/${washingPriceListId}/copy?${qs.stringify({
            startDate,
            endDate
          })}`
        );
      }}>

      <p>Копировать прейскурант</p>
    </Popconfirm>);

};
